import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  "/newProduct",
  "/brandCenter",
  "/noticeCenter",
  "/helpCenter",
  "/searchProduct",
  "/hotProduct",
  "/productDetail",
  "/index",
  "/login",
  "/allProduct",
  "/auth-redirect",
]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  if (to.meta) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        "content",
        window.localStorage.getItem("yunsuwangluokeywords")
      );
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        window.localStorage.getItem("yunsuwangluodescription")
      );
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }

  // start progress bar
  NProgress.start();
  // 页面标题, 这里注释掉动态显示标题,方便在打包后修改为网站备案名称
  // document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      const hasGetUserInfo = store.getters.name;
      if (hasGetUserInfo) {
        next();
      } else {
        try {
          // 获取用户信息
          // await store.dispatch('user/getInfo')
          next();
        } catch (error) {
          // token可存储在vuex中
          // remove token and go to login page to re-login
          // await store.dispatch('user/resetToken')
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
